module.exports = __webpack_public_path__ + "static/img/evgeny-tchebotarev-aiwuLjLPFnU-unsplash_thumb.79f0b6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/evgeny-tchebotarev-aiwuLjLPFnU-unsplash_thumb.png
// module id = Jf2a
// module chunks = 4